import React from "react";
import { PrimaryText, MediumText } from "../../../../text";
import { getLocalizedProperty } from "../../../../../utils/i18n";
var HeaderComponent = function(param) {
    var row = param.row;
    return /*#__PURE__*/ React.createElement(PrimaryText, null, /*#__PURE__*/ React.createElement(MediumText, null, getLocalizedProperty(row, "label")));
};
export default HeaderComponent;
